module.exports = __webpack_public_path__ + "static/media/hotel-bed-2.7b8ac9c6.svg";